module.exports = __webpack_public_path__ + "static/Scholarship_america_logo-b9531ddce9d57293beacfc56f8a8462a.png";